<template>
  <div class="financial_info">
    <el-container>
      <el-main style="overflow:hidden">
        <el-row>
          <el-col :span="11">
            <el-collapse
              class="financial_collapse"
              v-model="activeName"
              @change="financialCollapseChange"
              accordion
            >
              <el-collapse-item name="1" style="">
                <template slot="title">
                  &emsp;
                  <img src="../../../assets/images/wpsp/zichan.png" />&nbsp;
                  <span class="title-topic">客户当前资产总额</span>
                  <i
                    style="width:74.2%;text-align:right;font-style:normal;"
                  >￥{{total_map.current_assets}}</i>
                </template>
                <div>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">&nbsp;</el-col>
                    <el-col :span="9" :offset="1">行内信息</el-col>
                    <el-col :span="9" :offset="1">行外信息</el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">本人</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="self_inline.selfInBank" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="self_outline.selfOutBank" placeholder="请输入行外资产总额" />
                      <span
                        style="color:red"
                        v-if="error[8].personal.bool"
                      >{{error[8].personal.text}}</span>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px" v-if="spouseFinanceFlag">
                    <el-col class="setWid" :span="1" :offset="1">配偶</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="spouse_inline.spouseInBank" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="spouse_outline.spouseOutBank" placeholder="请输入行外资产总额" />
                      <span style="color:red" v-if="error[8].spouse.bool">{{error[8].spouse.text}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2" class="options">
                <template slot="title">
                  &emsp;&nbsp;
                  <span class="title-topic">现金及活存</span>
                  &emsp;&emsp;&emsp;&emsp;
                  <i
                    style="width:75%;text-align:right;font-style:normal;"
                  >￥{{total_map.cash_total | fmtCustFinanceInfo}}</i>
                </template>
                <!--编辑配偶资产信息-->
                <div>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">&nbsp;</el-col>
                    <el-col :span="9" :offset="1">行内信息</el-col>
                    <el-col :span="9" :offset="1">行外信息</el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">本人</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="self_inline.cash" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="self_outline.cash" placeholder="请输入行外现金及活存" />
                      <span
                        style="color:red"
                        v-if="error[0].personal.bool"
                      >{{error[0].personal.text}}</span>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px" v-if="spouseFinanceFlag">
                    <el-col class="setWid" :span="1" :offset="1">配偶</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="spouse_inline.cash" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="spouse_outline.cash" placeholder="请输入行外现金及活存" />
                      <span style="color:red" v-if="error[0].spouse.bool">{{error[0].spouse.text}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="3" class="options">
                <template slot="title">
                  &emsp;&nbsp;
                  <span class="title-topic">定期存款</span>
                  &emsp;&emsp;&emsp;&emsp;&emsp;
                  <i
                    style="width:75%;text-align:right;font-style:normal;"
                  >￥{{total_map.deposit_total | fmtCustFinanceInfo}}</i>
                </template>
                <!--编辑配偶资产信息-->
                <div>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">&nbsp;</el-col>
                    <el-col :span="9" :offset="1">行内信息</el-col>
                    <el-col :span="9" :offset="1">行外信息</el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">本人</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="self_inline.deposit" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="self_outline.deposit" placeholder="请输入行外定期存款" />
                      <span
                        style="color:red"
                        v-if="error[1].personal.bool"
                      >{{error[1].personal.text}}</span>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px" v-if="spouseFinanceFlag">
                    <el-col class="setWid" :span="1" :offset="1">配偶</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="spouse_inline.deposit" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="spouse_outline.deposit" placeholder="请输入行外定期存款" />
                      <span style="color:red" v-if="error[1].spouse.bool">{{error[1].spouse.text}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="4" class="options">
                <template slot="title">
                  &emsp;&nbsp;
                  <span class="title-topic">债券</span>
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                  <i
                    style="width:75%;text-align:right;font-style:normal;"
                  >￥{{total_map.bond_total | fmtCustFinanceInfo}}</i>
                </template>
                <!--编辑配偶资产信息-->
                <div>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">&nbsp;</el-col>
                    <el-col :span="9" :offset="1">行内信息</el-col>
                    <el-col :span="9" :offset="1">行外信息</el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">本人</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="self_inline.bond" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="self_outline.bond" placeholder="请输入行外国债" />
                      <span
                        style="color:red"
                        v-if="error[2].personal.bool"
                      >{{error[2].personal.text}}</span>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px" v-if="spouseFinanceFlag">
                    <el-col class="setWid" :span="1" :offset="1">配偶</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="spouse_inline.bond" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="spouse_outline.bond" placeholder="请输入行外国债" />
                      <span style="color:red" v-if="error[2].spouse.bool">{{error[2].spouse.text}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="5" class="options">
                <template slot="title">
                  &emsp;&nbsp;
                  <span class="title-topic">基金</span>
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                  <i
                    style="width:75%;text-align:right;font-style:normal;"
                  >￥{{total_map.fund_total | fmtCustFinanceInfo}}</i>
                </template>
                <!--编辑配偶资产信息-->
                <div>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">&nbsp;</el-col>
                    <el-col :span="9" :offset="1">行内信息</el-col>
                    <el-col :span="9" :offset="1">行外信息</el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">本人</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="self_inline.fund" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="self_outline.fund" placeholder="请输入行外基金" />
                      <span
                        style="color:red"
                        v-if="error[3].personal.bool"
                      >{{error[3].personal.text}}</span>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px" v-if="spouseFinanceFlag">
                    <el-col class="setWid" :span="1" :offset="1">配偶</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="spouse_inline.fund" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="spouse_outline.fund" placeholder="请输入行外基金" />
                      <span style="color:red" v-if="error[3].spouse.bool">{{error[3].spouse.text}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="6" class="options">
                <template slot="title">
                  &emsp;&nbsp;
                  <span class="title-topic">理财</span>
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                  <i
                    style="width:75%;text-align:right;font-style:normal;"
                  >￥{{total_map.finance_total | fmtCustFinanceInfo}}</i>
                </template>
                <!--编辑配偶资产信息-->
                <div>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">&nbsp;</el-col>
                    <el-col :span="9" :offset="1">行内信息</el-col>
                    <el-col :span="9" :offset="1">行外信息</el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">本人</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="self_inline.finance" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="self_outline.finance" placeholder="请输入行外理财" />
                      <span
                        style="color:red"
                        v-if="error[4].personal.bool"
                      >{{error[4].personal.text}}</span>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px" v-if="spouseFinanceFlag">
                    <el-col class="setWid" :span="1" :offset="1">配偶</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="spouse_inline.finance" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="spouse_outline.finance" placeholder="请输入行外理财" />
                      <span style="color:red" v-if="error[4].spouse.bool">{{error[4].spouse.text}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="7" class="options">
                <template slot="title">
                  &emsp;&nbsp;
                  <span class="title-topic">贵金属</span>
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                  <i
                    style="width:75%;text-align:right;font-style:normal;"
                  >￥{{total_map.precious_metal_total | fmtCustFinanceInfo}}</i>
                </template>
                <!--编辑配偶资产信息-->
                <div>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">&nbsp;</el-col>
                    <el-col :span="9" :offset="1">行内信息</el-col>
                    <el-col :span="9" :offset="1">行外信息</el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">本人</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="self_inline.precious_metal" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="self_outline.precious_metal" placeholder="请输入行外贵金属" />
                      <span
                        style="color:red"
                        v-if="error[5].personal.bool"
                      >{{error[5].personal.text}}</span>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px" v-if="spouseFinanceFlag">
                    <el-col class="setWid" :span="1" :offset="1">配偶</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="spouse_inline.precious_metal" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="spouse_outline.precious_metal" placeholder="请输入行外贵金属" />
                      <span style="color:red" v-if="error[5].spouse.bool">{{error[5].spouse.text}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="8" class="options">
                <template slot="title">
                  &emsp;&nbsp;
                  <span class="title-topic">其他</span>
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                  <i
                    style="width:75%;text-align:right;font-style:normal;"
                  >￥{{total_map.other_money_total | fmtCustFinanceInfo}}</i>
                </template>
                <!--编辑配偶资产信息-->
                <div>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">&nbsp;</el-col>
                    <el-col :span="9" :offset="1">行内信息</el-col>
                    <el-col :span="9" :offset="1">行外信息</el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">本人</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="self_inline.other_money" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="self_outline.other_money" placeholder="请输入行外其他" />
                      <span
                        style="color:red"
                        v-if="error[6].personal.bool"
                      >{{error[6].personal.text}}</span>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px" v-if="spouseFinanceFlag">
                    <el-col class="setWid" :span="1" :offset="1">配偶</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="spouse_inline.other_money" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="spouse_outline.other_money" placeholder="请输入行外其他" />
                      <span style="color:red" v-if="error[6].spouse.bool">{{error[6].spouse.text}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="9">
                <template slot="title">
                  &emsp;
                  <img src="../../../assets/images/wpsp/fuzhai.png" />&nbsp;
                  <span class="title-topic">客户当前负债总额</span>
                  <i
                    style="width:74.2%;text-align:right;font-style:normal;"
                    class="totalMoney"
                  >￥{{total_map.current_debt}}</i>
                </template>
<div>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">&nbsp;</el-col>
                    <el-col :span="9" :offset="1">行内信息</el-col>
                    <el-col :span="9" :offset="1">行外信息</el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">本人</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="self_inline.selfInDebt" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="self_outline.selfOutDebt" placeholder="请输入行外负债总额" />
                      <span
                        style="color:red"
                        v-if="error[9].personal.bool"
                      >{{error[9].personal.text}}</span>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px" v-if="spouseFinanceFlag">
                    <el-col class="setWid" :span="1" :offset="1">配偶</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="spouse_inline.spouseInDebt" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="spouse_outline.spouseOutDebt" placeholder="请输入行外负债总额" />
                      <span style="color:red" v-if="error[9].spouse.bool">{{error[9].spouse.text}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="10" class="options">
                <template slot="title">
                  &emsp;&nbsp;
                  <span class="title-topic">债务</span>
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                  <i
                    style="width:75%;text-align:right;font-style:normal;"
                  >￥{{total_map.debt_total }}</i>
                </template>
                <!--编辑配偶资产信息-->
                <div>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">&nbsp;</el-col>
                    <el-col :span="9" :offset="1">行内信息</el-col>
                    <el-col :span="9" :offset="1">行外信息</el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px">
                    <el-col class="setWid" :span="1" :offset="1">本人</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="self_inline.debt" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="self_outline.debt" placeholder="请输入行外债务" />
                      <span
                        style="color:red"
                        v-if="error[7].personal.bool"
                      >{{error[7].personal.text}}</span>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom:10px" v-if="spouseFinanceFlag">
                    <el-col class="setWid" :span="1" :offset="1">配偶</el-col>
                    <el-col :span="9" :offset="1">
                      <el-input :disabled="true" v-model="spouse_inline.debt" />
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-input v-model="spouse_outline.debt" placeholder="请输入行外债务" />
                      <span style="color:red" v-if="error[7].spouse.bool">{{error[7].spouse.text}}</span>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-col>
          <el-col :span="12" :offset="1">
            <el-card class="box-card" style="background-color:#F2F4F9">
              <span class="inComeDiv">
                <span
                  class="inComeTopic"
                >年收入:&nbsp;￥{{income_total.custIncomeTotal |fmtCustFinanceInfo}}</span>&nbsp;
                <i class="el-icon-edit-outline inComeBtn" @click="editCustIncomeClick()"></i>
              </span>
              <div id="incomeContainer" style="width:100%;height:215px;"></div>
              <div id="incomeContainerWarn" class="nonDataFlag">暂无数据</div>
              <span class="payDiv">
                <span class="payTopic">年支出:&nbsp;￥{{expend_total.annualExpend | fmtCustFinanceInfo}}</span>&nbsp;
                <i class="el-icon-edit-outline payBtn" @click="editCustExpendClick()"></i>
              </span>
              <div id="expendContainer" style="width:100%;height:195px;"></div>
              <div id="expendContainerWarn" class="nonDataFlag">暂无数据</div>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <!--年收入编辑框-->
    <div>
      <el-dialog
        title="修改全年总收入"
        :visible.sync="dialogVisible_income"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="dialogWidthOfIncome"
        @close="Close"
      >
        <div v-if="spouseFinanceFlag">
          <el-row style="margin-bottom:15px">
            <el-col :span="5" :offset="1">&nbsp;</el-col>
            <el-col :span="8" :offset="1">本人</el-col>
            <el-col :span="8" :offset="1">配偶</el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="5" :offset="1" style="padding-top:4px;">
              工资收入(元)&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="self_income.salaryIncome" placeholder="请输入本人工资收入" />
              <span style="color:red" v-if="incomeError[0].personal.bool">
                {{incomeError[0].personal.text}}
              </span>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="spouse_income.salaryIncome" placeholder="请输入配偶工资收入" hidden />
           <span style="color:red" v-if="incomeError[0].spouse.bool">
                {{incomeError[0].spouse.text}}
              </span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="5" :offset="1" style="padding-top:4px;">
              金融投资收入(元)&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="self_income.investIncome" placeholder="请输入本人金融投资收入" />
            <span style="color:red" v-if="incomeError[1].personal.bool">
                {{incomeError[1].personal.text}}
              </span>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="spouse_income.investIncome" placeholder="请输入配偶金融投资收入" hidden />
             <span style="color:red" v-if="incomeError[1].spouse.bool">
                {{incomeError[1].spouse.text}}
              </span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="5" :offset="1" style="padding-top:4px;">
              其他收入(元)&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="self_income.otherIncome" placeholder="请输入本人其他收入" />
            <span style="color:red" v-if="incomeError[2].personal.bool">
                {{incomeError[2].personal.text}}
              </span>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="spouse_income.otherIncome" placeholder="请输入配偶其他收入" />
            <span style="color:red" v-if="incomeError[2].spouse.bool">
                {{incomeError[2].spouse.text}}
              </span>
            </el-col>
          </el-row>
        </div>
        <div v-if="!spouseFinanceFlag">
          <el-row style="margin-bottom:15px">
            <el-col :span="6" :offset="1">&nbsp;</el-col>
            <el-col :span="15" :offset="1">本人</el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="6" :offset="1" style="padding-top:4px;">
              工资收入(元)&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="15" :offset="1">
              <el-input v-model="self_income.salaryIncome" placeholder="请输入本人工资收入" />
             <span style="color:red" v-if="incomeError[0].personal.bool">
                {{incomeError[0].personal.text}}
              </span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="6" :offset="1" style="padding-top:4px;">
              金融投资收入(元)&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="15" :offset="1">
              <el-input v-model="self_income.investIncome" placeholder="请输入本人金融投资收入" />
            <span style="color:red" v-if="incomeError[1].personal.bool">
                {{incomeError[1].personal.text}}
              </span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="6" :offset="1" style="padding-top:4px;">
              其他收入(元)&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="15" :offset="1">
              <el-input v-model="self_income.otherIncome" placeholder="请输入本人其他收入" />
             <span style="color:red" v-if="incomeError[2].personal.bool">
                {{incomeError[2].personal.text}}
              </span>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_income = false">取消</el-button>
          <el-button type="primary" :loading="incomeLoading" @click="editCustIncome()">确定</el-button>
        </span>
      </el-dialog>
    </div>
    <!--年支出编辑框-->
    <div>
      <el-dialog
        title="修改全年总支出"
        :visible.sync="dialogVisible_expend"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="dialogWidthOfExpend"
        @close="Close"
      >
        <div v-if="spouseFinanceFlag">
          <el-row style="margin-bottom:15px">
            <el-col :span="5" :offset="1">&nbsp;</el-col>
            <el-col :span="8" :offset="1">本人</el-col>
            <el-col :span="8" :offset="1">配偶</el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="5" :offset="1" style="padding-top:4px;">
              日常支出(元)&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="self_expend.dailyExpend" placeholder="请输入本人日常支出" />
            <span style="color:red" v-if="expenditureError[0].personal.bool">
              {{expenditureError[0].personal.text}}
            </span>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="spouse_expend.dailyExpend" placeholder="请输入配偶日常支出" />
             <span style="color:red" v-if="expenditureError[0].spouse.bool">
              {{expenditureError[0].spouse.text}}
            </span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="5" :offset="1" style="padding-top:4px;">
              <span>贷款及利息支出(元)</span>&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="self_expend.loanInterestExpend" placeholder="请输入本人贷款及利息支出" />
            <span style="color:red" v-if="expenditureError[1].personal.bool">
              {{expenditureError[1].personal.text}}
            </span>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="spouse_expend.loanInterestExpend" placeholder="请输入配偶贷款及利息支出" />
             <span style="color:red" v-if="expenditureError[1].spouse.bool">
              {{expenditureError[1].spouse.text}}
            </span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="5" :offset="1" style="padding-top:4px;">
              其他支出(元)&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="self_expend.otherExpend" placeholder="请输入本人其他支出" />
            <span style="color:red" v-if="expenditureError[2].personal.bool">
              {{expenditureError[2].personal.text}}
            </span>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="spouse_expend.otherExpend" placeholder="请输入配偶其他支出" />
              <span style="color:red" v-if="expenditureError[2].spouse.bool">
              {{expenditureError[2].spouse.text}}
            </span>
            </el-col>
          </el-row>
        </div>
        <div v-if="!spouseFinanceFlag">
          <el-row style="margin-bottom:15px">
            <el-col :span="6" :offset="1">&nbsp;</el-col>
            <el-col :span="15" :offset="1">本人</el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="6" :offset="1" style="padding-top:4px;">
              日常支出(元)&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="15" :offset="1">
              <el-input v-model="self_expend.dailyExpend" placeholder="请输入本人日常支出" />
            <span style="color:red" v-if="expenditureError[0].personal.bool">
              {{expenditureError[0].personal.text}}
            </span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="6" :offset="1" style="padding-top:4px;">
              <span>贷款及利息支出(元)</span>&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="15" :offset="1">
              <el-input v-model="self_expend.loanInterestExpend" placeholder="请输入本人贷款及利息支出" />
            <span style="color:red" v-if="expenditureError[1].personal.bool">
              {{expenditureError[1].personal.text}}
            </span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px;text-align:right">
            <el-col :span="6" :offset="1" style="padding-top:4px;">
              其他支出(元)&nbsp;
              <el-tooltip content="略略略" placement="bottom" effect="light" popper-class="atooltip">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="15" :offset="1">
              <el-input v-model="self_expend.otherExpend" placeholder="请输入本人其他支出" />
            <span style="color:red" v-if="expenditureError[2].personal.bool">
              {{expenditureError[2].personal.text}}
            </span>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_expend = false">取消</el-button>
          <el-button type="primary" :loading="expendLoading" @click="editCustExpend();">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: 'keyboardView',
  data() {
    return {
      // 当前选中的折叠框
      activeName: '',
      // 判断当前关闭的折叠框是否是资产总额或是负债总额
      activeNameTwo: '',
      name: '',
      activeNameTmp: '',
      // 收入统计图刻度最大值
      maxIncomeEchartVal: 100,
      // 支出统计图刻度最大值
      maxExpendEchartVal: 100,
      maxMoneyLength: 13,
      // 客户号
      cis: '',
      // 错误编码 E00000：成功
      errorCode: 'E00000',
      // 客户收入模态框宽度
      dialogWidthOfIncome: '700px',
      // 客户支出模态框宽度
      dialogWidthOfExpend: '755px',
      // 激活折叠框赋值标识。默认未激活
      initFlag: true,
      // 当前编辑的客户资产执行状态。默认未执行
      execedFlag: false,
      // “请输入数值，并保留两位小数”的警告框弹出控制器
      moneyRegShowFlag: true,
      // 未维护配偶时，配偶资产栏显示标识。默认不显示
      spouseFinanceFlag: false,
      // 未维护配偶时，配偶收入栏显示标识。默认不显示
      spouseFinanceFlag: false,
      // 未维护配偶时，配偶支出栏显示标识。默认不显示
      spouseFinanceFlag: false,
      // 编辑收入时重复提交标识
      incomeLoading: false,
      // 编辑支出时重复提交标识
      expendLoading: false,
      // 编辑总资产标记
      editFinanceTotalFlag: false,
      // 编辑总负债标记
      editDebtTotalFlag: false,
      // 本人
      self_flag: '0',
      // 配偶
      spouse_flag: '1',
      // 行内
      inline_flag: '0',
      // 行外
      outline_flag: '1',
      // 客户全年总收入编辑框状态
      dialogVisible_income: false,
      // 客户全年总支出编辑框状态
      dialogVisible_expend: false,
      // 客户当前各个资产以及负债总额集合
      total_map: {
        // 客户当前资产总额
        current_assets: '0.00',
        // 客户当前负债总额
        current_debt: '0.00',
        // 客户当前资产总额
        current_assets_Two: '0.00',
        // 客户当前负债总额
        current_debt_Two: '0.00',
        // 现金及活存总额
        cash_total: '0.00',
        // 定期存款总额
        deposit_total: '0.00',
        // 债券总额
        bond_total: '0.00',
        // 基金总额
        fund_total: '0.00',
        // 理财总额
        finance_total: '0.00',
        // 贵金属总额
        precious_metal_total: '0.00',
        // 其他总额
        other_money_total: '0.00',
        // 债务总额
        debt_total: '0.00',
      },
      // 本人行内
      self_inline: {
        // 总额
        selfInBank: '0.00',
        // 负债总额
        selfInDebt: '0.00',
        // 现金及活存
        cash: '0.00',
        // 定期存款
        deposit: '0.00',
        // 债券
        bond: '0.00',
        // 基金
        fund: '0.00',
        // 理财
        finance: '0.00',
        // 贵金属
        precious_metal: '0.00',
        // 其他
        other_money: '0.00',
        // 债务
        debt: '0.00',
      },
      // 本人行外
      self_outline: {
        // 总额
        selfOutBank: '0.00',
        // 负债总额
        selfOutDebt: '0.00',
        // 现金及活存
        cash: '0.00',
        // 定期存款
        deposit: '0.00',
        // 债券
        bond: '0.00',
        // 基金
        fund: '0.00',
        // 理财
        finance: '0.00',
        // 贵金属
        precious_metal: '0.00',
        // 其他
        other_money: '0.00',
        // 债务
        debt: '0.00',
      },
      // 配偶行内
      spouse_inline: {
        // 总额
        spouseInBank: '0.00',
        // 负债总额
        spouseInDebt: '0.00',
        // 现金及活存
        cash: '0.00',
        // 定期存款
        deposit: '0.00',
        // 债券
        bond: '0.00',
        // 基金
        fund: '0.00',
        // 理财
        finance: '0.00',
        // 贵金属
        precious_metal: '0.00',
        // 其他
        other_money: '0.00',
        // 债务
        debt: '0.00',
      },
      // 配偶行外
      spouse_outline: {
        // 总额
        spouseOutBank: '0.00',
        // 债务总额
        spouseOutDebt: '0.00',
        // 现金及活存
        cash: '0.00',
        // 定期存款
        deposit: '0.00',
        // 债券
        bond: '0.00',
        // 基金
        fund: '0.00',
        // 理财
        finance: '0.00',
        // 贵金属
        precious_metal: '0.00',
        // 其他
        other_money: '0.00',
        // 债务
        debt: '0.00',
      },
      // 总收入
      income_total: {
        // 年收入
        custIncomeTotal: '0.00',
        // 工资收入
        salaryIncome: '0.00',
        // 金融投资收入
        investIncome: '0.00',
        // 其他收入
        otherIncome: '0.00',
      },
      // 本人收入
      self_income: {
        // 工资收入
        salaryIncome: '0.00',
        // 金融投资收入
        investIncome: '0.00',
        // 其他收入
        otherIncome: '0.00',
      },
      // 配偶收入
      spouse_income: {
        // 工资收入
        salaryIncome: '0.00',
        // 金融投资收入
        investIncome: '0.00',
        // 其他收入
        otherIncome: '0.00',
      },
      // 总支出
      expend_total: {
        // 年支出
        annualExpend: '0.00',
        // 日常支出
        dailyExpend: '0.00',
        // 贷款及利息支出
        loanInterestExpend: '0.00',
        // 其他支出
        otherExpend: '0.00',
      },
      // 本人支出
      self_expend: {
        // 日常支出
        dailyExpend: '0.00',
        // 贷款及利息支出
        loanInterestExpend: '0.00',
        // 其他支出
        otherExpend: '0.00',
      },
      // 配偶支出
      spouse_expend: {
        // 日常支出
        dailyExpend: '0.00',
        // 贷款及利息支出
        loanInterestExpend: '0.00',
        // 其他支出
        otherExpend: '0.00',
      },
      // 编辑客户资产接口入参
      edit_finance_data: {},
      // 年收入报错信息
      incomeError: [
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 工资收入
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 金融投资收入
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 其他收入
      ],
      // 年支出报错信息
      expenditureError: [
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 日常支出
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 贷款及利息支出
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 其他支出
      ],
      // 资产编辑报错信息
      error: [
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 现金
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 定期存款
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 国债
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 基金
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 理财
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 贵金属
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 其他
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 债务
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 总额
        {
          personal: { text: '', bool: false },
          spouse: { text: '', bool: false },
        }, // 负债总额
      ],
    };
  },
  // 侦听器
  watch: {
    // 本人行外字段监听
    'self_outline.cash': function (value) {
      this.setValOfFinance('selfCash', value, 0, 1); // 第三个值判断哪个框第四个值判断时本人还是配偶（1：本人2：配偶）
    },
    'self_outline.deposit': function (value) {
      this.setValOfFinance('selfDeposit', value, 1, 1);
    },
    'self_outline.fund': function (value) {
      this.setValOfFinance('selfFund', value, 3, 1);
    },
    'self_outline.bond': function (value) {
      this.setValOfFinance('selfBond', value, 2, 1);
    },
    'self_outline.finance': function (value) {
      this.setValOfFinance('selfFinance', value, 4, 1);
    },
    'self_outline.precious_metal': function (value) {
      this.setValOfFinance('selfPreciousMetal', value, 5, 1);
    },
    'self_outline.other_money': function (value) {
      this.setValOfFinance('selfOtherMoney', value, 6, 1);
    },
    'self_outline.debt': function (value) {
      this.setValOfFinance('selfDebt', value, 7, 1);
    },
    'self_outline.selfOutBank': function (value) {
      this.setValOfFinance('selfSelfOutBank', value, 8, 1);
    },
    'self_outline.selfOutDebt': function (value) {
      this.setValOfFinance('selfSelfOutDebt', value, 9, 1);
    },
    // 配偶行外字段监听
    'spouse_outline.cash': function (value) {
      this.setValOfFinance('spouseCash', value, 0, 2);
    },
    'spouse_outline.deposit': function (value) {
      this.setValOfFinance('spouseDeposit', value, 1, 2);
    },
    'spouse_outline.fund': function (value) {
      this.setValOfFinance('spouseFund', value, 3, 2);
    },
    'spouse_outline.bond': function (value) {
      this.setValOfFinance('spouseBond', value, 2, 2);
    },
    'spouse_outline.finance': function (value) {
      this.setValOfFinance('spouseFinance', value, 4, 2);
    },
    'spouse_outline.precious_metal': function (value) {
      this.setValOfFinance('spousePreciousMetal', value, 5, 2);
    },
    'spouse_outline.other_money': function (value) {
      this.setValOfFinance('spouseOtherMoney', value, 6, 2);
    },
    'spouse_outline.debt': function (value) {
      this.setValOfFinance('spouseDebt', value, 7, 2);
    },
    'spouse_outline.spouseOutBank': function (value) {
      this.setValOfFinance('spouseSpouseOutBank', value, 8, 2);
    },
    'spouse_outline.spouseOutDebt': function (value) {
      this.setValOfFinance('spouseSpouseOutDebt', value, 9, 2);
    },
    '$store.state.wpspAddSpouse': function (value) {
      // 2是新增，3是修改 1是删除
      if (value === '2') {
        this.getFinanceMsg(1);
        this.spouseFinanceFlag = true;
        this.spouseFinanceFlag = true;
        this.spouseFinanceFlag = true;
      } else if (value === '3') {
        console.log('333==', value);
        this.getFinanceMsg(1);
        this.spouseFinanceFlag = true;
        this.spouseFinanceFlag = true;
        this.spouseFinanceFlag = true;
      } else {
        this.getCustIncomeMsg();
        this.getCustExpendMsg();
        this.getFinanceMsg('');
        this.spouseFinanceFlag = false;
        this.spouseFinanceFlag = false;
        this.spouseFinanceFlag = false;
        // 本人
        this.spouse_income.salaryIncome = this.moneyFilter(0);
        this.spouse_income.investIncome = this.moneyFilter(0);
        this.spouse_income.otherIncome = this.moneyFilter(0);
        // 配偶
        this.spouse_expend.dailyExpend = this.moneyFilter(0);
        this.spouse_expend.loanInterestExpend = this.moneyFilter(0);
        this.spouse_expend.otherExpend = this.moneyFilter(0);
      }
    },
  },
  // 局部指令注册
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  created() {
    this.cis = JSON.parse(sessionStorage.getItem('cis'));
  },
  mounted() {
    document.addEventListener('click', this.edit);
    // 初始化客户资产信息
    this.getFinanceMsg('');
    // 初始化客户收入支出信息
    this.initIncExpMsg();
  },
  methods: {

    Close() {
      for (let index = 0; index < this.incomeError.length; index++) {
        this.incomeError[index].spouse.bool = false;
        this.incomeError[index].personal.bool = false;
      }
      for (let index = 0; index < this.expenditureError.length; index++) {
        this.expenditureError[index].spouse.bool = false;
        this.expenditureError[index].personal.bool = false;
      }
    },
    /** ******************************Action********************************* */
    // 防止录入客户资产时，折叠框自动收缩
    edit(e) {
      let str = e.target.className;
      str = str.split(' ');
      if (
        str[0] !== 'el-collapse-item__header'
        && str[0] !== ''
        && str[0] !== 'el-input__inner'
        && str[0] !== 'el-collapse-item__arrow'
        && str[0] !== 'title-topic'
        && str[0] !== 'el-row'
      ) {
        this.activeNameTmp = '';
      }
      e.stopPropagation();
    },
    // 客户资产折叠框编辑
    setValOfFinance(key, value, index, character) {
      const testReg = /^([1-9]\d{0,9}|0)((\.\d{1,2})?)$/;
      const num = this.disMoneyFilter(value);
      // 长度校验
      if ((num * 1).toFixed(2).length > 13) {
        if (character === 1) {
          switch (index) {
            case 0:
              this.error[index].personal.text = '整数位不得超过10位';
              this.error[index].personal.bool = true;
              break;
            case 1:
              this.error[index].personal.text = '整数位不得超过10位';
              this.error[index].personal.bool = true;
              break;
            case 2:
              this.error[index].personal.text = '整数位不得超过10位';
              this.error[index].personal.bool = true;
              break;
            case 3:
              this.error[index].personal.text = '整数位不得超过10位';
              this.error[index].personal.bool = true;
              break;
            case 4:
              this.error[index].personal.text = '整数位不得超过10位';
              this.error[index].personal.bool = true;
              break;
            case 5:
              this.error[index].personal.text = '整数位不得超过10位';
              this.error[index].personal.bool = true;
              break;
            case 6:
              this.error[index].personal.text = '整数位不得超过10位';
              this.error[index].personal.bool = true;
              break;
            case 7:
              this.error[index].personal.text = '整数位不得超过10位';
              this.error[index].personal.bool = true;
              break;
            case 8:
              this.error[index].personal.text = '整数位不得超过10位';
              this.error[index].personal.bool = true;
              break;
            case 9:
              this.error[index].personal.text = '整数位不得超过10位';
              this.error[index].personal.bool = true;
              break;
            default:
              break;
          }
          this.edit_finance_data.emptyKey = '1';
          return;
        }
        switch (index) {
          case 0:
            this.error[index].spouse.text = '整数位不得超过10位';
            this.error[index].spouse.bool = true;
            break;
          case 1:
            this.error[index].spouse.text = '整数位不得超过10位';
            this.error[index].spouse.bool = true;
            break;
          case 2:
            this.error[index].spouse.text = '整数位不得超过10位';
            this.error[index].spouse.bool = true;
            break;
          case 3:
            this.error[index].spouse.text = '整数位不得超过10位';
            this.error[index].spouse.bool = true;
            break;
          case 4:
            this.error[index].spouse.text = '整数位不得超过10位';
            this.error[index].spouse.bool = true;
            break;
          case 5:
            this.error[index].spouse.text = '整数位不得超过10位';
            this.error[index].spouse.bool = true;
            break;
          case 6:
            this.error[index].spouse.text = '整数位不得超过10位';
            this.error[index].spouse.bool = true;
            break;
          case 7:
            this.error[index].spouse.text = '整数位不得超过10位';
            this.error[index].spouse.bool = true;
            break;
          case 8:
            this.error[index].spouse.text = '整数位不得超过10位';
            this.error[index].spouse.bool = true;
            break;
          case 9:
            this.error[index].spouse.text = '整数位不得超过10位';
            this.error[index].spouse.bool = true;
            break;
          default:
            break;
        }
        this.edit_finance_data.emptyKey = '1';
        return;
      }
      if (character === 1) {
        switch (index) {
          case 0:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 1:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 2:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 3:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 4:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 5:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 6:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 7:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 8:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 9:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          default:
            break;
        }
      } else {
        switch (index) {
          case 0:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 1:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 2:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 3:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 4:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 5:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 6:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 7:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 8:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 9:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          default:
            break;
        }
      }
      // 格式校验
      if (!(testReg.test(num) || num === '0.00')) {
        if (this.moneyRegShowFlag) {
          // this.moneyRegShowFlag = false;
          const _this = this;
          if (character === 1) {
            switch (index) {
              case 0:
                this.error[index].personal.text = '请输入数值，并保留2位小数';
                this.error[index].personal.bool = true;
                break;
              case 1:
                this.error[index].personal.text = '请输入数值，并保留2位小数';
                this.error[index].personal.bool = true;
                break;
              case 2:
                this.error[index].personal.text = '请输入数值，并保留2位小数';
                this.error[index].personal.bool = true;
                break;
              case 3:
                this.error[index].personal.text = '请输入数值，并保留2位小数';
                this.error[index].personal.bool = true;
                break;
              case 4:
                this.error[index].personal.text = '请输入数值，并保留2位小数';
                this.error[index].personal.bool = true;
                break;
              case 5:
                this.error[index].personal.text = '请输入数值，并保留2位小数';
                this.error[index].personal.bool = true;
                break;
              case 6:
                this.error[index].personal.text = '请输入数值，并保留2位小数';
                this.error[index].personal.bool = true;
                break;
              case 7:
                this.error[index].personal.text = '请输入数值，并保留2位小数';
                this.error[index].personal.bool = true;
                break;
              case 8:
                this.error[index].personal.text = '请输入数值，并保留2位小数';
                this.error[index].personal.bool = true;
                break;
              case 9:
                this.error[index].personal.text = '请输入数值，并保留2位小数';
                this.error[index].personal.bool = true;
                break;
              default:
                break;
            }
            this.edit_finance_data.emptyKey = '1';
          } else {
            switch (index) {
              case 0:
                this.error[index].spouse.text = '请输入数值，并保留2位小数';
                this.error[index].spouse.bool = true;
                break;
              case 1:
                this.error[index].spouse.text = '请输入数值，并保留2位小数';
                this.error[index].spouse.bool = true;
                break;
              case 2:
                this.error[index].spouse.text = '请输入数值，并保留2位小数';
                this.error[index].spouse.bool = true;
                break;
              case 3:
                this.error[index].spouse.text = '请输入数值，并保留2位小数';
                this.error[index].spouse.bool = true;
                break;
              case 4:
                this.error[index].spouse.text = '请输入数值，并保留2位小数';
                this.error[index].spouse.bool = true;
                break;
              case 5:
                this.error[index].spouse.text = '请输入数值，并保留2位小数';
                this.error[index].spouse.bool = true;
                break;
              case 6:
                this.error[index].spouse.text = '请输入数值，并保留2位小数';
                this.error[index].spouse.bool = true;
                break;
              case 7:
                this.error[index].spouse.text = '请输入数值，并保留2位小数';
                this.error[index].spouse.bool = true;
                break;
              case 8:
                this.error[index].spouse.text = '请输入数值，并保留2位小数';
                this.error[index].spouse.bool = true;
                break;
              case 9:
                this.error[index].spouse.text = '请输入数值，并保留2位小数';
                this.error[index].spouse.bool = true;
                break;
              default:
                break;
            }
            this.edit_finance_data.emptyKey = '1';
          }
        }
        return;
      }
      if (character === 1) {
        switch (index) {
          case 0:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 1:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 2:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 3:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 4:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 5:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 6:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 7:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 8:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          case 9:
            this.error[index].personal.text = '';
            this.error[index].personal.bool = false;
            break;
          default:
            break;
        }
      } else {
        switch (index) {
          case 0:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 1:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 2:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 3:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 4:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 5:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 6:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 7:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 8:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          case 9:
            this.error[index].spouse.text = '';
            this.error[index].spouse.bool = false;
            break;
          default:
            break;
        }
      }
      // 赋值标记 默认赋值
      if (this.initFlag) {
        return;
      }
      this.edit_finance_data.emptyKey = '2';
      this.edit_finance_data[key] = this.disMoneyFilter(value);
    },
    /** ******************************Filter********************************* */
    // 保留两位小数，增加千分符
    moneyFilter(x) {
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // console.log(f)
      // 如果为空则返回默认值
      if (isNaN(f)) {
        return '0.00';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        // 补0
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。         👇是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 将分割的入参，重新拼起来  100,000.00
      return parts.join('.');
    },
    // 去掉千分符
    disMoneyFilter(x) {
      if (x.toString().indexOf(',') === -1) {
        return x;
      }
      return x.toString().replace(new RegExp(',', 'g'), '');
    },
    /** ******************************Init********************************* */
    // 初始化统计图
    initEcharts() {
      // 初始化客户收入柱状统计图
      this.initCustIncomeEchart();
      // 初始化客户支出柱状统计图
      this.initCustExpendEchart();
    },
    // 初始化客户收入支出信息
    initIncExpMsg() {
      // 查询客户收入信息
      this.getCustIncomeMsg();
      // 查询客户支出信息
      this.getCustExpendMsg();
    },
    // 初始化客户收入柱状统计图
    initCustIncomeEchart() {
      // 如果年收入为0则销毁统计图并显示'暂无数据'。
      if (
        this.income_total.custIncomeTotal === 0
        || this.income_total.custIncomeTotal === '0.00'
      ) {
        this.$echarts.dispose(document.querySelector('#incomeContainer'));
        document.querySelector('#incomeContainerWarn').style.display = 'block';
        return;
      }
      // 统计图刻度最大值随收入的变化而变化
      const tmp = this.income_total.salaryIncome >= this.income_total.investIncome
        ? this.income_total.salaryIncome
        : this.income_total.investIncome;
      const max = tmp >= this.income_total.otherIncome
        ? tmp
        : this.income_total.otherIncome;
      if (max.toString().indexOf('.') !== -1) {
        this.maxIncomeEchartVal = (max >> 0) + 1;
      } else {
        this.maxIncomeEchartVal = max;
      }
      // echarts配置
      const incomeOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '9%',
          bottom: '10%',
          top: '5%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          min: 0,
          max: this.maxIncomeEchartVal,
          name: '(万元)',
          nameGap: 30,
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
            },
          },
          nameTextStyle: {
            verticalAlign: 'bottom',
            lineHeight: '-30',
          },
        },
        yAxis: {
          type: 'category',
          data: ['其他收入', '金融投资收益', '工资收入'],
          axisTick: {
            alignWithLabel: true,
          },
        },
        series: [
          {
            name: '年收入(万元)',
            type: 'bar',
            data: [
              this.income_total.otherIncome.toFixed(2),
              this.income_total.investIncome.toFixed(2),
              this.income_total.salaryIncome.toFixed(2),
            ],
            itemStyle: {
              normal: {
                color: '#3E98FE',
              },
            },
            barWidth: 30,
          },
        ],
      };
      // 初始化echarts
      const chartOfIncome = this.$echarts.init(
        document.querySelector('#incomeContainer'),
      );
      chartOfIncome.setOption(incomeOption);
      // 隐藏'暂无数据'提示
      document.querySelector('#incomeContainerWarn').style.display = 'none';
    },
    // 初始化客户支出柱状统计图
    initCustExpendEchart() {
      // 如果年支出为0则销毁统计图并显示'暂无数据'。
      if (
        this.expend_total.annualExpend === 0
        || this.expend_total.annualExpend === '0.00'
      ) {
        this.$echarts.dispose(document.querySelector('#expendContainer'));
        document.querySelector('#expendContainerWarn').style.display = 'block';
        return;
      }
      // 统计图刻度最大值随收入的变化而变化
      const tmp = this.expend_total.dailyExpend >= this.expend_total.loanInterestExpend
        ? this.expend_total.dailyExpend
        : this.expend_total.loanInterestExpend;
      const max = tmp >= this.expend_total.otherExpend
        ? tmp
        : this.expend_total.otherExpend;
      if (max.toString().indexOf('.') !== -1) {
        this.maxExpendEchartVal = (max >> 0) + 1;
      } else {
        this.maxExpendEchartVal = max;
      }
      // echarts配置
      const expendOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '1%',
          right: '9%',
          bottom: '10%',
          top: '5%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          min: 0,
          max: this.maxExpendEchartVal,
          name: '(万元)',
          nameGap: 30,
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
            },
          },
          nameTextStyle: {
            verticalAlign: 'bottom',
            lineHeight: '-30',
          },
        },
        yAxis: {
          type: 'category',
          data: ['其他支出', '贷款及利息支出', '日常支出'],
          axisTick: {
            alignWithLabel: true,
          },
        },
        series: [
          {
            name: '年支出(万元)',
            type: 'bar',
            data: [
              this.expend_total.otherExpend.toFixed(2),
              this.expend_total.loanInterestExpend.toFixed(2),
              this.expend_total.dailyExpend.toFixed(2),
            ],
            itemStyle: {
              normal: {
                color: '#F86B6C',
              },
            },
            barWidth: 30,
          },
        ],
      };
      // 初始化echarts
      this.$nextTick(() => {
        const chartOfExpend = this.$echarts.init(
          document.querySelector('#expendContainer'),
        );
        chartOfExpend.setOption(expendOption);
      });
      document.querySelector('#expendContainerWarn').style.display = 'none';
    },
    /** ******************************Select********************************* */
    // 查询客户财务信息。入参x为控制配偶组件是否显示的标记，解决每次查询时配偶组件闪动的问题。
    getFinanceMsg(x) {
      const params = {
        sendInsCode: 'mock', // 类型：String  可有字段  备注：发送机构代码
        receiveInsCode: 'mock', // 类型：String  可有字段  备注：接受结构代码
        sendSystemId: 'mock', // 类型：String  可有字段  备注：发送系统编号
        systemToken: 'mock', // 类型：String  可有字段  备注：系统认证token
        userToken: 'mock', // 类型：String  必有字段  备注：用户认证token
        version: 'mock', // 类型：String  可有字段  备注：接口版本
        data: {
          cis: this.cis,
        },
      };
      this.$_post(this.$API.getFinance, params)
        .then((res) => {
          if (
            typeof res.data.selfAndSpouseList === 'undefined'
            || typeof res.data.financeSum === 'undefined'
            || res.data.selfAndSpouseList.length < 1
          ) {
            return;
          }
          this.execedFlag = true;
          let spouseFlag = 0;
          for (let i = 0; i < res.data.selfAndSpouseList.length; i++) {
            const financeInfo = res.data.selfAndSpouseList[i];
            // 行内
            if (financeInfo.isBank === this.inline_flag) {
              // 本人
              if (financeInfo.isSelf === this.self_flag) {
                this.self_inline.cash = this.moneyFilter(financeInfo.cash);
                this.self_inline.deposit = this.moneyFilter(
                  financeInfo.deposit,
                );
                this.self_inline.bond = this.moneyFilter(financeInfo.bond);
                this.self_inline.fund = this.moneyFilter(financeInfo.fund);
                this.self_inline.finance = this.moneyFilter(
                  financeInfo.finance,
                );
                this.self_inline.precious_metal = this.moneyFilter(
                  financeInfo.preciousMetal,
                );
                this.self_inline.other_money = this.moneyFilter(
                  financeInfo.otherMoney,
                );
                this.self_inline.debt = this.moneyFilter(financeInfo.debt);
                this.self_inline.selfInBank = this.moneyFilter(financeInfo.currentAssets);
                this.self_inline.selfInDebt = this.moneyFilter(financeInfo.currentDebt);
              }
              // 配偶
              if (financeInfo.isSelf === this.spouse_flag) {
                this.spouse_inline.cash = this.moneyFilter(financeInfo.cash);
                this.spouse_inline.deposit = this.moneyFilter(
                  financeInfo.deposit,
                );
                this.spouse_inline.bond = this.moneyFilter(financeInfo.bond);
                this.spouse_inline.fund = this.moneyFilter(financeInfo.fund);
                this.spouse_inline.finance = this.moneyFilter(
                  financeInfo.finance,
                );
                this.spouse_inline.precious_metal = this.moneyFilter(
                  financeInfo.preciousMetal,
                );
                this.spouse_inline.other_money = this.moneyFilter(
                  financeInfo.otherMoney,
                );
                this.spouse_inline.debt = this.moneyFilter(financeInfo.debt);
                this.spouse_inline.spouseInBank = this.moneyFilter(financeInfo.currentAssets);
                this.spouse_inline.spouseInDebt = this.moneyFilter(financeInfo.currentDebt);

                spouseFlag++;
              }
            }
            // 行外
            if (financeInfo.isBank === this.outline_flag) {
              // 本人
              if (financeInfo.isSelf === this.self_flag) {
                this.self_outline.cash = this.moneyFilter(financeInfo.cash);
                this.self_outline.deposit = this.moneyFilter(
                  financeInfo.deposit,
                );
                this.self_outline.bond = this.moneyFilter(financeInfo.bond);
                this.self_outline.fund = this.moneyFilter(financeInfo.fund);
                this.self_outline.finance = this.moneyFilter(
                  financeInfo.finance,
                );
                this.self_outline.precious_metal = this.moneyFilter(
                  financeInfo.preciousMetal,
                );
                this.self_outline.other_money = this.moneyFilter(
                  financeInfo.otherMoney,
                );
                this.self_outline.debt = this.moneyFilter(financeInfo.debt);
                this.self_outline.selfOutBank = this.moneyFilter(financeInfo.currentAssets);
                this.self_outline.selfOutDebt = this.moneyFilter(financeInfo.currentDebt);
              }
              // 配偶
              if (financeInfo.isSelf === this.spouse_flag) {
                this.spouse_outline.cash = this.moneyFilter(financeInfo.cash);
                this.spouse_outline.deposit = this.moneyFilter(
                  financeInfo.deposit,
                );
                this.spouse_outline.bond = this.moneyFilter(financeInfo.bond);
                this.spouse_outline.fund = this.moneyFilter(financeInfo.fund);
                this.spouse_outline.finance = this.moneyFilter(
                  financeInfo.finance,
                );
                this.spouse_outline.precious_metal = this.moneyFilter(
                  financeInfo.preciousMetal,
                );
                this.spouse_outline.other_money = this.moneyFilter(
                  financeInfo.otherMoney,
                );
                this.spouse_outline.debt = this.moneyFilter(financeInfo.debt);
                this.spouse_outline.spouseOutBank = this.moneyFilter(financeInfo.currentAssets);
                this.spouse_outline.spouseOutDebt = this.moneyFilter(financeInfo.currentDebt);
                spouseFlag++;
              }
            }
          }
          const finance = res.data.financeSum;
          // 总资产
          this.total_map.current_assets = this.moneyFilter(
            finance.currentAssetsTotal,
          );
          this.total_map.current_assets_Two = this.moneyFilter(
            finance.currentAssetsTotal,
          );
          this.total_map.current_debt = this.moneyFilter(
            finance.currentDebtTotal,
          );
          this.total_map.current_debt_Two = this.moneyFilter(
            finance.currentDebtTotal,
          );
          this.total_map.cash_total = finance.cashTotal;
          this.total_map.deposit_total = finance.depositTotal;
          this.total_map.bond_total = finance.bondTotal;
          this.total_map.fund_total = finance.fundTotal;
          this.total_map.finance_total = finance.financeTotal;
          this.total_map.precious_metal_total = finance.preciousMetalTotal;
          this.total_map.other_money_total = finance.otherMoneyTotal;
          this.total_map.debt_total = this.moneyFilter(finance.debtTotal);
          if (x !== '') {
            return;
          }
          if (spouseFlag <= 0) {
            this.spouseFinanceFlag = false;
            return;
          }
          this.spouseFinanceFlag = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 查询客户收入信息
    getCustIncomeMsg() {
      const params = {
        sendInsCode: 'mock', // 类型：String  可有字段  备注：发送机构代码
        receiveInsCode: 'mock', // 类型：String  可有字段  备注：接受结构代码
        sendSystemId: 'mock', // 类型：String  可有字段  备注：发送系统编号
        systemToken: 'mock', // 类型：String  可有字段  备注：系统认证token
        userToken: 'mock', // 类型：String  必有字段  备注：用户认证token
        version: 'mock', // 类型：String  可有字段  备注：接口版本
        data: {
          cis: this.cis,
        },
      };
      this.$_post(this.$API.getIncome, params)
        .then((res) => {
          if (
            typeof res.data.custIncomeInfos !== 'undefined'
            && res.data.custIncomeInfos.length > 0
          ) {
            const arr = res.data.custIncomeInfos;
            arr.forEach((val) => {
              console.log('接口返回客户收入', res.data);
              if (val.isSelf === '0') {
                // 客户收入
                this.self_income.salaryIncome = this.moneyFilter(
                  val.salaryIncome,
                );
                this.self_income.investIncome = this.moneyFilter(
                  val.investIncome,
                );
                this.self_income.otherIncome = this.moneyFilter(
                  val.otherIncome,
                );
              } else {
                // 客户配偶收入
                this.spouse_income.salaryIncome = this.moneyFilter(
                  val.salaryIncome,
                );
                this.spouse_income.investIncome = this.moneyFilter(
                  val.investIncome,
                );
                this.spouse_income.otherIncome = this.moneyFilter(
                  val.otherIncome,
                );
              }
            });
            if (res.data.custIncomeInfos.length > 1) {
            } else {
              this.spouseFinanceFlag = false;
            }
            // 统计图赋值
            const custerIncomeTotal = res.data.custIncomeInfoListDTO;
            this.income_total.custIncomeTotal = custerIncomeTotal.custIncomeTotal;
            this.income_total.salaryIncome = Math.round((Math.round(custerIncomeTotal.salaryIncomeTotal) / 10000) * 100) / 100;
            this.income_total.investIncome = Math.round((Math.round(custerIncomeTotal.investIncomeTotal) / 10000) * 100) / 100;
            this.income_total.otherIncome = Math.round((Math.round(custerIncomeTotal.otherIncomeTotal) / 10000) * 100) / 100;
          }
          // 初始化客户收入柱状统计图
          this.initCustIncomeEchart();
        })
        .catch((error) => {
          console.log(error);
          // 如果报错则提示'暂无数据'
          document.querySelector('#incomeContainerWarn').style.display = 'block';
        });
    },
    // 查询客户支出信息
    getCustExpendMsg() {
      const params = {
        sendInsCode: 'mock', // 类型：String  可有字段  备注：发送机构代码
        receiveInsCode: 'mock', // 类型：String  可有字段  备注：接受结构代码
        sendSystemId: 'mock', // 类型：String  可有字段  备注：发送系统编号
        systemToken: 'mock', // 类型：String  可有字段  备注：系统认证token
        userToken: 'mock', // 类型：String  必有字段  备注：用户认证token
        version: 'mock', // 类型：String  可有字段  备注：接口版本
        data: {
          cis: this.cis,
        },
      };
      this.$_post(this.$API.getExpend, params)
        .then((res) => {
          if (
            typeof res.data.custExpendInfo !== 'undefined'
            && res.data.custExpendInfo.length > 0
          ) {
            const arr = res.data.custExpendInfo;
            arr.forEach((val) => {
              console.log('接口返回客户收入', res.data);
              if (val.isSelf === '0') {
                // 客户收入
                this.self_expend.dailyExpend = this.moneyFilter(
                  val.dailyExpend,
                );
                this.self_expend.loanInterestExpend = this.moneyFilter(
                  val.loanInterestExpend,
                );
                this.self_expend.otherExpend = this.moneyFilter(
                  val.otherExpend,
                );
              } else {
                // 客户配偶收入
                this.spouse_expend.dailyExpend = this.moneyFilter(
                  val.dailyExpend,
                );
                this.spouse_expend.loanInterestExpend = this.moneyFilter(
                  val.loanInterestExpend,
                );
                this.spouse_expend.otherExpend = this.moneyFilter(
                  val.otherExpend,
                );
              }
            });
            if (res.data.custExpendInfo.length > 1) {
            } else {
              this.spouseFinanceFlag = false;
            }
            const custerExpendTotal = res.data.custExpendInfoListDTO;
            this.expend_total.annualExpend = custerExpendTotal.custExpendTotal;
            this.expend_total.dailyExpend = Math.round((Math.round(custerExpendTotal.dailyExpendTotal) / 10000) * 100) / 100;
            this.expend_total.loanInterestExpend = Math.round((Math.round(custerExpendTotal.loanInterestExpendTotal) / 10000) * 100) / 100;
            this.expend_total.otherExpend = Math.round((Math.round(custerExpendTotal.otherExpendTotal) / 10000) * 100) / 100;
          }
          // 初始化客户支出柱状统计图
          this.initCustExpendEchart();
        })
        .catch((error) => {
          console.log(error);
          document.querySelector('#expendContainerWarn').style.display = 'block';
        });
    },
    /** ******************************Update********************************* */
    // 编辑客户资产
    editCustFinance() {
      console.log(this.edit_finance_data, '1111*****');
      const paramsJSON = JSON.stringify(this.edit_finance_data);
      if (paramsJSON === '{}') {
        return;
      }
      if (this.edit_finance_data.emptyKey === '1') {
        this.initFlag = true;
        this.edit_finance_data = {};
        this.getFinanceMsg(1);
        return;
      }
      let params = {};
      if (this.edit_finance_data.selfSelfOutBank !== undefined
        && this.edit_finance_data.spouseSpouseOutBank === undefined) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                currentAssets: this.edit_finance_data.selfSelfOutBank,
              },
            ],
          },
        };
      } else if (this.edit_finance_data.selfSelfOutBank === undefined
        && this.edit_finance_data.spouseSpouseOutBank !== undefined) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                currentAssets: this.edit_finance_data.spouseSpouseOutBank,
              },
            ],
          },
        };
      } else if (this.edit_finance_data.selfSelfOutBank !== undefined
        && this.edit_finance_data.spouseSpouseOutBank !== undefined) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                // cis:'223',
                self: this.self_flag,
                bank: this.outline_flag,
                currentAssets: this.edit_finance_data.selfSelfOutBank,
              },
              {
                cis: this.cis,
                // cis:'223',
                self: this.spouse_flag,
                bank: this.outline_flag,
                currentAssets: this.edit_finance_data.spouseSpouseOutBank,
              },
            ],
          },
        };
      } else if (this.edit_finance_data.selfSelfOutDebt !== undefined
        && this.edit_finance_data.spouseSpouseOutDebt === undefined) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                currentDebt: this.edit_finance_data.selfSelfOutDebt,
              },
            ],
          },
        };
      } else if (this.edit_finance_data.selfSelfOutDebt === undefined
        && this.edit_finance_data.spouseSpouseOutDebt !== undefined) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                currentDebt: this.edit_finance_data.spouseSpouseOutDebt,
              },
            ],
          },
        };
      } else if (this.edit_finance_data.selfSelfOutDebt !== undefined
        && this.edit_finance_data.spouseSpouseOutDebt !== undefined) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                currentDebt: this.edit_finance_data.selfSelfOutDebt,
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                currentDebt: this.edit_finance_data.spouseSpouseOutDebt,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfCash !== undefined
        && this.edit_finance_data.spouseCash === undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                cash: this.edit_finance_data.selfCash,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfCash === undefined
        && this.edit_finance_data.spouseCash !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                cash: this.edit_finance_data.spouseCash,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfCash !== undefined
        && this.edit_finance_data.spouseCash !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                cash: this.edit_finance_data.selfCash,
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                cash: this.edit_finance_data.spouseCash,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfDeposit !== undefined
        && this.edit_finance_data.spouseDeposit === undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                deposit: this.edit_finance_data.selfDeposit,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfDeposit === undefined
        && this.edit_finance_data.spouseDeposit !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                deposit: this.edit_finance_data.spouseDeposit,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfDeposit !== undefined
        && this.edit_finance_data.spouseDeposit !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                deposit: this.edit_finance_data.selfDeposit,
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                deposit: this.edit_finance_data.spouseDeposit,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfBond !== undefined
        && this.edit_finance_data.spouseBond === undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                bond: this.edit_finance_data.selfBond,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfBond === undefined
        && this.edit_finance_data.spouseBond !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                bond: this.edit_finance_data.spouseBond,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfBond !== undefined
        && this.edit_finance_data.spouseBond !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                bond: this.edit_finance_data.selfBond,
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                bond: this.edit_finance_data.spouseBond,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfFund !== undefined
        && this.edit_finance_data.spouseFund === undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                fund: this.edit_finance_data.selfFund,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfFund === undefined
        && this.edit_finance_data.spouseFund !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                fund: this.edit_finance_data.spouseFund,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfFund !== undefined
        && this.edit_finance_data.spouseFund !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                fund: this.edit_finance_data.selfFund,
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                fund: this.edit_finance_data.spouseFund,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfFinance !== undefined
        && this.edit_finance_data.spouseFinance === undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                finance: this.edit_finance_data.selfFinance,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfFinance === undefined
        && this.edit_finance_data.spouseFinance !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                finance: this.edit_finance_data.spouseFinance,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfFinance !== undefined
        && this.edit_finance_data.spouseFinance !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                finance: this.edit_finance_data.selfFinance,
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                finance: this.edit_finance_data.spouseFinance,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfPreciousMetal !== undefined
        && this.edit_finance_data.spousePreciousMetal === undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                preciousMetal: this.edit_finance_data.selfPreciousMetal,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfPreciousMetal === undefined
        && this.edit_finance_data.spousePreciousMetal !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                preciousMetal: this.edit_finance_data.spousePreciousMetal,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfPreciousMetal !== undefined
        && this.edit_finance_data.spousePreciousMetal !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                preciousMetal: this.edit_finance_data.selfPreciousMetal,
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                preciousMetal: this.edit_finance_data.spousePreciousMetal,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfOtherMoney !== undefined
        && this.edit_finance_data.spouseOtherMoney === undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                otherMoney: this.edit_finance_data.selfOtherMoney,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfOtherMoney === undefined
        && this.edit_finance_data.spouseOtherMoney !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                otherMoney: this.edit_finance_data.spouseOtherMoney,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfOtherMoney !== undefined
        && this.edit_finance_data.spouseOtherMoney !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                otherMoney: this.edit_finance_data.selfOtherMoney,
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                otherMoney: this.edit_finance_data.spouseOtherMoney,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfDebt !== undefined
        && this.edit_finance_data.spouseDebt === undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                debt: this.edit_finance_data.selfDebt,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfDebt === undefined
        && this.edit_finance_data.spouseDebt !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                debt: this.edit_finance_data.spouseDebt,
              },
            ],
          },
        };
      } else if (
        this.edit_finance_data.selfDebt !== undefined
        && this.edit_finance_data.spouseDebt !== undefined
      ) {
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                bank: this.outline_flag,
                debt: this.edit_finance_data.selfDebt,
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                bank: this.outline_flag,
                debt: this.edit_finance_data.spouseDebt,
              },
            ],
          },
        };
      }
      this.$_post(this.$API.editFinance, params)
        .then((res) => {
          if (res.status === undefined) {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          } else if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
          }

          this.initFlag = true;
          this.edit_finance_data = {};
          this.getFinanceMsg(1);
        })
        .catch((error) => {
          this.initFlag = true;
          this.edit_finance_data = {};
          this.getFinanceMsg(1);
        });
    },
    // 编辑客户收入
    editCustIncome() {
      let errorIncomeFlag = false;
      const testRegText = /^[\d.]+$/;
      // const testRegFormat = /^([1-9]\d{0,9}|0)((\.\d{1,2})?)$/;
      const testRegFormat = /^([1-9]\d{0,9}|0)((\.\d+)?)$/;
      const salaryIncomeSelf = this.disMoneyFilter(this.self_income.salaryIncome);
      const investIncomeSelf = this.disMoneyFilter(this.self_income.investIncome);
      const otherIncomeSelf = this.disMoneyFilter(this.self_income.otherIncome);
      // 非空校验&&非法字符校验
      if (salaryIncomeSelf == '' || !testRegText.test(salaryIncomeSelf) === true) {
        this.incomeError[0].personal.bool = true;
        this.incomeError[0].personal.text = '请输入数值，并保留两位小数';
        errorIncomeFlag = true;
      } else if (!testRegFormat.test(salaryIncomeSelf)) {
        this.incomeError[0].personal.bool = true;
        this.incomeError[0].personal.text = '整数位不得超过10位';
        errorIncomeFlag = true;
      } else {
        this.incomeError[0].personal.bool = false;
        this.incomeError[0].personal.text = '';
      }
      if (investIncomeSelf == '' || !testRegText.test(investIncomeSelf) === true) {
        this.incomeError[1].personal.bool = true;
        this.incomeError[1].personal.text = '请输入数值，并保留两位小数';
        errorIncomeFlag = true;
      } else if (!testRegFormat.test(investIncomeSelf)) {
        this.incomeError[1].personal.bool = true;
        this.incomeError[1].personal.text = '整数位不得超过10位';
        errorIncomeFlag = true;
      } else {
        this.incomeError[1].personal.bool = false;
        this.incomeError[1].personal.text = '';
      }
      if (otherIncomeSelf == '' || !testRegText.test(otherIncomeSelf) === true) {
        this.incomeError[2].personal.bool = true;
        this.incomeError[2].personal.text = '请输入数值，并保留两位小数';
        errorIncomeFlag = true;
      } else if (!testRegFormat.test(otherIncomeSelf)) {
        this.incomeError[2].personal.bool = true;
        this.incomeError[2].personal.text = '整数位不得超过10位';
        errorIncomeFlag = true;
      } else {
        this.incomeError[2].personal.bool = false;
        this.incomeError[2].personal.text = '';
      }
      let params = {
        data: {
          list: [
            {
              cis: this.cis,
              self: this.self_flag,
              salaryIncome: salaryIncomeSelf,
              investIncome: investIncomeSelf,
              otherIncome: otherIncomeSelf,
            },
          ],
        },
      };

      // 配偶参数校验
      if (this.spouseFinanceFlag) {
        const salaryIncomeSpouse = this.disMoneyFilter(this.spouse_income.salaryIncome);
        const investIncomeSpouse = this.disMoneyFilter(this.spouse_income.investIncome);
        const otherIncomeSpouse = this.disMoneyFilter(this.spouse_income.otherIncome);
        // 验证格式
        if (salaryIncomeSpouse == '' || !testRegText.test(salaryIncomeSpouse) === true) {
          this.incomeError[0].spouse.bool = true;
          this.incomeError[0].spouse.text = '请输入数值，并保留两位小数';
          errorIncomeFlag = true;
        } else if (!testRegFormat.test(salaryIncomeSpouse)) {
          this.incomeError[0].spouse.bool = true;
          this.incomeError[0].spouse.text = '整数位不得超过10位';
          errorIncomeFlag = true;
        } else {
          this.incomeError[0].spouse.bool = false;
          this.incomeError[0].spouse.text = '';
        }
        if (investIncomeSpouse == '' || !testRegText.test(investIncomeSpouse) === true) {
          this.incomeError[1].spouse.bool = true;
          this.incomeError[1].spouse.text = '请输入数值，并保留两位小数';
          errorIncomeFlag = true;
        } else if (!testRegFormat.test(investIncomeSpouse)) {
          this.incomeError[1].spouse.bool = true;
          this.incomeError[1].spouse.text = '整数位不得超过10位';
          errorIncomeFlag = true;
        } else {
          this.incomeError[1].spouse.bool = false;
          this.incomeError[1].spouse.text = '';
        }
        if (otherIncomeSpouse == '' || !testRegText.test(otherIncomeSpouse) === true) {
          this.incomeError[2].spouse.bool = true;
          this.incomeError[2].spouse.text = '请输入数值，并保留两位小数';
          errorIncomeFlag = true;
        } else if (!testRegFormat.test(otherIncomeSpouse)) {
          this.incomeError[2].spouse.bool = true;
          this.incomeError[2].spouse.text = '整数位不得超过10位';
          errorIncomeFlag = true;
        } else {
          this.incomeError[2].spouse.bool = false;
          this.incomeError[2].spouse.text = '';
        }
        if (errorIncomeFlag) {
          return;
        }
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                salaryIncome: salaryIncomeSelf,
                investIncome: investIncomeSelf,
                otherIncome: otherIncomeSelf,
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                salaryIncome: salaryIncomeSpouse,
                investIncome: investIncomeSpouse,
                otherIncome: otherIncomeSpouse,
              },
            ],
          },
        };
      }
      this.incomeLoading = true;
      this.$_post(this.$API.editIncome, params)
        .then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
          this.dialogVisible_income = false;
          this.incomeLoading = false;
          this.getCustIncomeMsg();
        })
        .catch((error) => {
          console.log(error);
          this.dialogVisible_income = false;
          this.incomeLoading = false;
          this.getCustIncomeMsg();
        });
    },
    // 编辑客户支出
    editCustExpend() {
      let errorExpendFlag = false;
      // 格式校验
      const testReg = /^([1-9]\d{0,9}|0)((\.\d{1,2})?)$/;
      if (!testReg.test(this.disMoneyFilter(this.self_expend.dailyExpend))) {
        this.expenditureError[0].personal.bool = true;
        this.expenditureError[0].personal.text = '请输入数值，并保留两位小数';
        errorExpendFlag = true;
      } else {
        this.expenditureError[0].personal.bool = false;
        this.expenditureError[0].personal.text = '';
      }
      if (
        !testReg.test(this.disMoneyFilter(this.self_expend.loanInterestExpend))
      ) {
        this.expenditureError[1].personal.bool = true;
        this.expenditureError[1].personal.text = '请输入数值，并保留两位小数';
        errorExpendFlag = true;
      } else {
        this.expenditureError[1].personal.bool = false;
        this.expenditureError[1].personal.text = '';
      }
      if (!testReg.test(this.disMoneyFilter(this.self_expend.otherExpend))) {
        this.expenditureError[2].personal.bool = true;
        this.expenditureError[2].personal.text = '请输入数值，并保留两位小数';
        errorExpendFlag = true;
      } else {
        this.expenditureError[2].personal.bool = false;
        this.expenditureError[2].personal.text = '';
      }
      let params = {
        data: {
          list: [
            {
              cis: this.cis,
              self: this.self_flag,
              dailyExpend: this.disMoneyFilter(this.self_expend.dailyExpend),
              loanInterestExpend: this.disMoneyFilter(
                this.self_expend.loanInterestExpend,
              ),
              otherExpend: this.disMoneyFilter(this.self_expend.otherExpend),
            },
          ],
        },
      };
      // 配偶参数校验
      if (this.spouseFinanceFlag) {
        // 格式校验
        if (!testReg.test(this.disMoneyFilter(this.spouse_expend.dailyExpend))) {
          this.expenditureError[0].spouse.bool = true;
          this.expenditureError[0].spouse.text = '请输入数值，并保留两位小数';
          errorExpendFlag = true;
        } else {
          this.expenditureError[0].spouse.bool = false;
          this.expenditureError[0].spouse.text = '';
        }
        if (!testReg.test(this.disMoneyFilter(this.spouse_expend.loanInterestExpend))) {
          this.expenditureError[1].spouse.bool = true;
          this.expenditureError[1].spouse.text = '请输入数值，并保留两位小数';
          errorExpendFlag = true;
        } else {
          this.expenditureError[1].spouse.bool = false;
          this.expenditureError[1].spouse.text = '';
        }
        if (!testReg.test(this.disMoneyFilter(this.spouse_expend.otherExpend))) {
          this.expenditureError[2].spouse.bool = true;
          this.expenditureError[2].spouse.text = '请输入数值，并保留两位小数';
          errorExpendFlag = true;
        } else {
          this.expenditureError[2].spouse.bool = false;
          this.expenditureError[2].spouse.text = '';
        }
        if (errorExpendFlag) {
          return;
        }
        params = {
          data: {
            list: [
              {
                cis: this.cis,
                self: this.self_flag,
                dailyExpend: this.disMoneyFilter(this.self_expend.dailyExpend),
                loanInterestExpend: this.disMoneyFilter(
                  this.self_expend.loanInterestExpend,
                ),
                otherExpend: this.disMoneyFilter(this.self_expend.otherExpend),
              },
              {
                cis: this.cis,
                self: this.spouse_flag,
                dailyExpend: this.disMoneyFilter(
                  this.spouse_expend.dailyExpend,
                ),
                loanInterestExpend: this.disMoneyFilter(
                  this.spouse_expend.loanInterestExpend,
                ),
                otherExpend: this.disMoneyFilter(this.spouse_expend.otherExpend),
              },
            ],
          },
        };
      }
      this.expendLoading = true;
      this.$_post(this.$API.editExpend, params)
        .then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
          }
          this.dialogVisible_expend = false;
          this.expendLoading = false;
          this.getCustExpendMsg();
        })
        .catch((error) => {
          console.log(error);
          this.dialogVisible_expend = false;
          this.expendLoading = false;
          this.getCustExpendMsg();
        });
    },
    // 总资产输入框显示控制器
    editFinanceTotalCtrl() {
      this.editFinanceTotalFlag = true;
    },
    // 总负债输入框显示控制器
    editDebtTotalCtrl() {
      this.editDebtTotalFlag = true;
    },
    // 年收入按钮的单击事件
    editCustIncomeClick() {
      this.dialogVisible_income = true;
      this.getCustIncomeMsg();
    },
    // 年支出按钮的单击事件
    editCustExpendClick() {
      this.dialogVisible_expend = true;
      this.getCustExpendMsg();
    },
    /** ******************************Event********************************* */
    financialCollapseChange(activeNames) {
      // 初始化标志(页面加载时，防止监听修改客户资产的编辑数据入参)
      if (!(this.edit_finance_data.emptyKey === '1')) {
        this.editCustFinance();
        this.initFlag = false;
        for (let index = 0; index < this.error.length; index++) {
          this.error[index].personal.bool = false;
          this.error[index].spouse.bool = false;
        }
      } else {
        this.editCustFinance();
      }
    },
    // 编辑资产总额
    editFincanceTotal() {
      console.log('编辑资产总额');
      const params = {
        data: {
          list: [{
            cis: this.cis,
            self: '0',
            bank: '0',
            currentAssets: '12',
            currentDebt: '5',
          }],
        },
      };
      this.$_post('/wpsp/inner/cust_finance_info/update_finance_data', params)
        .then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
          this.getFinanceMsg(1);
          this.editFinanceTotalFlag = false;
        })
        .catch((error) => {
          console.log(error);
          this.editFinanceTotalFlag = false;
        });
      // this.initFlag = true;
      // const testReg = /^([1-9]{1,})|(0)\.{0,1}\d{0,}$/;
      // const curAssets = `${(this.disMoneyFilter(this.total_map.current_assets) * 1).toFixed(2)}`;
      // const curAssetsTwo = this.disMoneyFilter(this.total_map.current_assets_Two);
      // if (!testReg.test(curAssets) && curAssets != '') {
      //   this.total_map.current_assets = this.total_map.current_assets_Two;
      //   this.$message({
      //     message: '请输入数值，并保留两位小数',
      //     type: 'warning',
      //     showClose: true,
      //     duration: 3000,
      //   });
      //   this.editFinanceTotalFlag = false;
      //   return;
      // } if (curAssets.length > this.maxMoneyLength) {
      //   this.total_map.current_assets = this.total_map.current_assets_Two;
      //   this.$message({
      //     message: '整数位不得超过10位',
      //     type: 'warning',
      //     showClose: true,
      //   });
      //   this.editFinanceTotalFlag = false;
      // } else {
      //   const params = {
      //     data: {
      //     // 类型：Object  必有字段  备注：参数类型
      //       cis: this.cis, // 类型：String  必有字段  备注：客户号
      //       self: this.self_flag, // 类型：String  必有字段  备注：是否本人，0本人，1配偶
      //       bank: this.outline_flag, // 类型：String  必有字段  备注：是否行内，0行内，1行外
      //       currentAssets: curAssets,
      //     },
      //   };
      //   this.$_post(this.$API.editFinanceTotalReq, params)
      //     .then((res) => {
      //       if (res.errorCode === this.errorCode) {
      //         this.$message({
      //           message: '成功',
      //           type: 'success',
      //           showClose: true,
      //         });
      //       } else {
      //         this.$message({
      //           message: res.errorMsg,
      //           type: 'error',
      //           showClose: true,
      //         });
      //       }
      //       this.getFinanceMsg(1);
      //       this.editFinanceTotalFlag = false;
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //       this.editFinanceTotalFlag = false;
      //     });
      // }
    },
    // 编辑负债总额
    editDebtTotal() {
      this.initFlag = true;
      const testReg = /^([1-9]{1,})|(0)\.{0,1}\d{0,}$/;
      const curDebt = `${(this.disMoneyFilter(this.total_map.current_debt) * 1).toFixed(2)}`;
      const curDebtTwo = this.disMoneyFilter(this.total_map.current_debt_Two);
      // 非法字符校验
      if (!testReg.test(curDebt) && curDebt != '') {
        this.total_map.current_debt = this.total_map.current_debt_Two;
        this.$message({
          message: '请输入数值，并保留两位小数',
          type: 'warning',
          showClose: true,
          duration: 3000,
        });
        this.editDebtTotalFlag = false;
        return;
      }
      // 长度校验
      if (curDebt.length > this.maxMoneyLength) {
        this.total_map.current_debt = this.total_map.current_debt_Two;
        this.$message({
          message: '整数位不可超过10位',
          type: 'warning',
          showClose: true,
        });
        this.editDebtTotalFlag = false;
        return;
      }
      const params = {
        data: {
          cis: this.cis,
          self: this.self_flag,
          bank: this.outline_flag,
          currentDebt: curDebt,
        },
      };
      this.$_post(this.$API.editDebtTotalReq, params)
        .then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
          this.getFinanceMsg(1);
          this.editDebtTotalFlag = false;
        })
        .catch((error) => {
          console.log(error);
          this.getFinanceMsg(1);
          this.editFinanceTotalFlag = false;
        });
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.edit);
  },
  beforeRouteLeave(to, from, next) {
    const a = 1;
    if (a === 1) {
      next();
    } else {
      next(false);
    }
  },
};
</script>
<style lang="scss">
.financial_info {
  .is-disabled .el-collapse-item__header {
    background-color: #edf6ff;
    color: black;
  }
  .is-disabled .el-icon-arrow-right {
    visibility: hidden;
  }
  .options .el-collapse-item__header:hover {
    background-color: #f5f7fa;
  }
  .is-active .el-collapse-item__header {
    background-color: #f5f7fa;
  }
  .el-dialog__body {
    padding: 0px 40px 0px 10px;
  }
  .el-dialog__footer {
    padding: 10px 40px 20px 20px;
  }
  .el-dialog__title {
    padding-left: 15px;
  }
}
</style>
<style scoped lang="scss">
.financial_info {
  background-color: white;
  .financial_collapse {
    border: 1px #e3e7ef solid;
    .is-disabled .el-collapse-item__header {
      background-color: #edf6ff !important;
    }
  }
  .inComeBtn,
  .payBtn {
    color: #52a3fd;
    font-size: larger;
    font-weight: bolder;
  }
  .el-icon-warning-outline {
    font-size: larger;
    font-weight: bolder;
    position: relative;
    top: 1px;
  }
  .el-icon-warning-outline:hover {
    color: #52a3fd;
    cursor: pointer;
  }
  .inComeBtn:hover,
  .payBtn:hover {
    cursor: pointer;
  }
  .inComeTopic,
  .payTopic {
    font-weight: bold;
  }
  .inComeDiv,
  .payDiv {
    padding-left: 44px;
  }
  .title-topic {
    width: 230px;
  }
  .setWid {
    width: 26px;
  }
  .nonDataFlag {
    text-align: center;
    position: relative;
    top: -110px;
    display: none;
    float: right;
    right: 320px;
  }
}
</style>
